import { AllowedPostSettings } from "@/services/channels/types";

export interface Post {
    id: string;
    name: string;
    postType: string;
    order: number;
    channelId: string;
    channelName: string;
    status: string;
    properties: Properties;
    fromDate: string;
    toDate: string;
    fromTime: string;
    toTime: string;
    allDay: boolean;
    neverending: boolean;
    recurenceType: RecurenceEnum;
    recurenceValues: Array<number>;
    yearly: string;
    createdBy: string;
    modifiedBy: string;
    time: string;
    containsPersonalData: boolean;
}

export interface PostPreviewInfo {
    id: string;
    name: string;
    channelId: string;
    channelName: string;
    modifiedBy: string;
    hasAccess: boolean;
}

export interface Properties { }

export enum PostTypeEnum {
    html = "HTML",
    fixedhtml = "FixedHTML",
    grab = "Grab",
    rss = "RSS",
    date = "Date",
    time = "Time",
    image = "Image",
    clock = "Clock",
    wayfinder = "Wayfinder",
    gallery = "Folder",
    video = "Video"
}

export enum RecurenceEnum {
    daily,
    weekly,
    monthly,
    yearly,
}

export enum WeekdaysEnum {
    monday = 1,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday
}

export const DatesOfMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];

export enum BehaviorEnum {
    adjust = "adjust",
    crop = "crop",
    letterBox = "letterBox",
    stretch = "stretch"
}

export interface ActiveDaysRequest {
    channelId: string;
    calendarStartDate: Date;
}

export interface PostActiveDaysRequest {
    postId: string;
    calendarStartDate: Date;
}

export interface MarkedDay {
    date: string;
    class: string;
}

export interface PostsFilterDtoIn {
    channelId: string,
    calendarDate: string
}

export interface CopyPost {
    postId: string,
    name: string,
}

export const Time = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00",
    "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00",
    "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "23:30"];

export interface CommonAllowedPostSettings extends AllowedPostSettings {
    styleId: string,
}
